
import * as defaultImport from "styled-components";
export * from "styled-components";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
